export const VENTILATOR = "VENTILATOR";
export const PATIENT = "PATIENT";
export const ERROR = "ERROR";

// valid for AVEA and VELA ventilators
export const ventilatorRegex = /^[A-Z]{3}\d{5}$/i;
export const bellavistaRegex = /^[A-Z]{2}\d{6}$/i;
export const pb840Regex = /^\d{10}$/i;

// event.KeyCode
export const ESCAPE = 27;
export const ENTER = 13;

// EventBus events
export const LOGIN_SUCCESS = "LOGIN_SUCCESS";
export const LOGOUT = "LOGOUT";
export const SESSION_TIMEOUT = "SESSION_TIMEOUT";
export const SETTINGS_CHANGED = "SETTINGS_CHANGED";
export const FOCUS_SEARCHBAR = "FOCUS_SEARCHBAR";
export const CLEAR_ASSOCIATION_MESSAGE = "CLEAR_ASSOCIATION_MESSAGE";

// invalid id modal text
export const PATIENT_NUMBER = "patient number";
export const VENTILATOR_SERIAL = "ventilator serial";
export const ERROR_TEXT = "identifier";
